//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2ClientUpdateEdit', {
//        templateUrl: 'views/components/views/p2ClientUpdateEdit/p2ClientUpdateEdit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'p2ClientUpdateEditService', function ($stateParams, p2ClientUpdateEditService) {

//            // #region GLOBAL VARIABLES & DEFINITIONS

//            const vm = this;
//            let clientUpdateId = $stateParams.clientupdate_id;

//            vm.model = {
//                edit: {},
//                refreshing: false
//            };

//            // #endregion GLOBAL VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await p2ClientUpdateEditService.getEdit({ clientupdate_id: clientUpdateId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON REFRESH FUNCTION

//            vm.refreshChanges = function () {
//                try {
//                    vm.model.refreshing = true;

//                    loadEdit();
//                } finally {
//                    vm.model.refreshing = false;
//                }
//            }

//            // #endregion BUTTON REFRESH FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
